const generateKey = (prefix = '') => {
   return `${ prefix }_${ Math.random().toString(36).slice(2) }`;
};

export {
   generateKey,
};
